import PropTypes from 'prop-types'

const eventContactProps = {
    fullName: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string
}

const eventIconProps = {
    calendar: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    docx: PropTypes.string.isRequired,
    pdf: PropTypes.string.isRequired,
    doc: PropTypes.string.isRequired
}

export { eventContactProps, eventIconProps }
